import {setPlanInfo} from 'store/subscriptionUi';
import {getWebAccessToken} from 'utils/webAuthSession';
import {getPlans, getProfile} from './billingApi';
import {planInfoFrom} from './billingModel';

/**
 * Loads the learner's plan and the plan catalog into the store, for the Upgrade pill, the
 * low-minutes pill and the full-screen plans. Returns what it stored (null when it could not).
 */
export const loadPlanInfo = () => async dispatch => {
  if (!getWebAccessToken()) return null;
  try {
    const [profile, {plans, catalog}] = await Promise.all([getProfile(), getPlans()]);
    const info = planInfoFrom(profile?.subscription, plans, catalog);
    dispatch(setPlanInfo(info));
    return info;
  } catch (error) {
    console.warn('[plans] Could not load the plan', {status: error?.response?.status || null});
    return null;
  }
};
